import { createSlice } from '@reduxjs/toolkit';

export const bodySlice = createSlice({
	name: 'body',
	initialState: {
		locked: false,
	},
	reducers: {
		setLocked: (state, action) => {
			state.locked = action.payload;
		},
	}
});

export const { setLocked } = bodySlice.actions;

export default bodySlice.reducer;